import React from "react";

import { Button, Col, Row } from "antd";
import Helmet from "react-helmet";
import * as styles from "./index.module.scss";

import Footer from "@components/footer";
import Header from "@components/header";
import TextCenterBanner from "@components/textCenterBanner";
import { useI18n } from "@src/i18n";

import pcImg from "@src/images/aboutMe/banner1.png";
import phoneImg from "@src/images/aboutMe/banner2.png";

import aboutImg1 from "@src/images/aboutMe/01.png";
import aboutImg2 from "@src/images/aboutMe/02.png";
import aboutImg3 from "@src/images/aboutMe/03.png";

import clockIcon from "@src/images/aboutMe/clock.png";
import mailIcon from "@src/images/aboutMe/mail.png";
import locationIcon from "@src/images/aboutMe/location.png";

import typePhoneNumberPhoneImg from "@src/images/aboutMe/飞书20210918-142421.png";
import typePhoneNumberPhoneImgEn from "@src/images/aboutMe/飞书20210918-142421-en.png";
import typePhoneNumberPcImg from "@src/images/aboutMe/飞书20210918-142430.png";
import typePhoneNumberPcImgEn from "@src/images/aboutMe/飞书20210918-142430-en.png";
import { navigate } from "gatsby";
const handleRegister = (event) => {
  event.preventDefault();
  navigate("/register/");
};
const AboutMePage = () => {
  const { locale, t } = useI18n();
  const intro = t("aboutPage.intro");
  const ctaPhoneImage =
    locale === "en-US" ? typePhoneNumberPhoneImgEn : typePhoneNumberPhoneImg;
  const ctaPcImage =
    locale === "en-US" ? typePhoneNumberPcImgEn : typePhoneNumberPcImg;

  return (
    <div className={styles.aboutMePage}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{t("aboutPage.title")}</title>
      </Helmet>
      <Header />
      <TextCenterBanner
        pcImg={pcImg}
        phoneImg={phoneImg}
        text={t("aboutPage.banner")}
      />
      <div className={styles.contentContainer}>
        <Row>
          {/* Pc端 */}
          <Col xs={0} sm={0} md={24}>
            <div className={styles.aboutContainer}>
              <div className={styles.title}>{t("aboutPage.aboutTitle")}</div>
              {intro.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </div>
            <div className={styles.imgContainer}>
              <img src={aboutImg1} alt="aboutImg1" />
              <img src={aboutImg2} alt="aboutImg2" />
              <img src={aboutImg3} alt="aboutImg3" />
            </div>
            <div className={styles.callUsContainer}>
              <div className={styles.inforContainer}>
                {/* <div className={styles.inforItem}>
                  <img src={phoneIcon} alt="phoneIcon" />
                  <div>公司电话：028-88888888</div>
                </div> */}
                <div className={styles.inforItem}>
                  <img src={mailIcon} alt="mailIcon" />
                  <div>
                    {t("aboutPage.emailLabel")}
                    {t("common.labelSeparator")}support@shoprise.com
                  </div>
                </div>
                <div className={styles.inforItem}>
                  <img src={locationIcon} alt="location" />
                  <div>{t("aboutPage.address")}</div>
                </div>
                <div className={styles.inforItem}>
                  <img src={clockIcon} alt="clockIcon" />
                  <div>
                    {t("aboutPage.consultTimeLabel")}
                    {t("common.labelSeparator")}
                    {t("aboutPage.consultTime")}
                  </div>
                </div>
              </div>
            </div>
          </Col>
          {/* 移动端 */}
          <Col xs={24} sm={24} md={0}>
            <div className={styles.smallContainer}>
              <div className={styles.title}>{t("aboutPage.aboutTitle")}</div>
              <div className={styles.introGroup}>
                <div className={styles.introItem}>
                  <p>{intro[0]}</p>
                  <img src={aboutImg1} alt="aboutImg1" />
                </div>
                <div className={styles.introItem}>
                  <p>{intro[1]}</p>
                  <img src={aboutImg2} alt="aboutImg2" />
                </div>
                <div className={styles.introItem}>
                  <p>{intro[2]}</p>
                  <img src={aboutImg3} alt="aboutImg3" />
                </div>
              </div>
              <div className={styles.inforContainer}>
                {/* <div className={styles.inforItem}>
                  <img src={phoneIcon} alt="phoneIcon" />
                  <div>
                    公司电话：
                    <br />
                    028-88888888
                  </div>
                </div> */}
                <div className={styles.inforItem}>
                  <img src={mailIcon} alt="mailIcon" />
                  <div>
                    {t("aboutPage.emailLabel")}
                    {t("common.labelSeparator")}
                    <br />
                    support@shoprise.com
                  </div>
                </div>

                <div className={styles.inforItem}>
                  <img src={locationIcon} alt="location" />
                  <div>
                    {t("aboutPage.addressLabel")}
                    {t("common.labelSeparator")}
                    <br />
                    {t("aboutPage.address")}
                  </div>
                </div>
                <div className={styles.inforItem}>
                  <img src={clockIcon} alt="clockIcon" />
                  <div>
                    {t("aboutPage.consultTimeLabel")}
                    {t("common.labelSeparator")}
                    <br />
                    {t("aboutPage.consultTime")}
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className={styles.typePhoneNumber}>
        <picture>
          <source media="(min-width: 960px)" srcSet={ctaPcImage} />
          <source media="(max-width: 960px)" srcSet={ctaPhoneImage} />
          <img
            src={ctaPcImage}
            alt=""
            style={{ width: "100%" }}
          />
        </picture>
        {/* <div className={styles.inputContainer}>
          <div className={styles.leftBox}>
            <input type="text" placeholder="请输入您的手机号" />
          </div>
          <div className={styles.rightBox}>
            <button onClick={handleLogin}>立享30天免费使用</button>
          </div>
        </div> */}

        <Button
          className={styles.primaryButton}
          shape="round"
          onClick={handleRegister}
          style={{ border: "none" }}
        >
          {t("aboutPage.cta")}
        </Button>
      </div>
      <Footer />
    </div>
  );
};

export default AboutMePage;
